import { render } from "./video-player.vue?vue&type=template&id=799ac20f"
import script from "./video-player.vue?vue&type=script&lang=js"
export * from "./video-player.vue?vue&type=script&lang=js"

import "./video-player.vue?vue&type=style&index=0&id=799ac20f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__